import { useQuery } from '@wyz/utils';
import { PurchaseQueryKeys, useManageSearch } from '~/purchase/api';
import { usePurchaseContext } from '~/purchase/context';
import { PurchaseSearchHelpers, QuoteHelpers } from '~/purchase/helpers';
import { useUpdateSearchQuery } from '~/purchase/hooks';
import { SEARCH_TYPE_ENUM } from '~/purchase/schemas';
import { IQuoteListState, IQuoteTyreOffer } from '~/purchase/types';

export function useQuoteFilterOffers(listState: IQuoteListState) {
  const { state } = usePurchaseContext();
  const customerId = state.targetCustomer?.id as string;
  const searchContext = {
    customerId: customerId,
    searchType: SEARCH_TYPE_ENUM.QUOTE,
  };
  const { list } = useManageSearch<IQuoteTyreOffer>({
    context: searchContext,
    list: listState.searchQuery
      ? {
          args: listState.searchQuery,
        }
      : undefined,
  });
  const query = useQuery<IQuoteTyreOffer[]>({
    queryKey: PurchaseQueryKeys.search.filtered(
      customerId,
      SEARCH_TYPE_ENUM.QUOTE,
      listState.searchQuery || {},
      { f: listState.filters, s: listState.sort, d: list.dataUpdatedAt },
    ),
    queryFn: () => {
      const filtered = PurchaseSearchHelpers.filterProducts(
        list.data?.data || [],
        listState,
      );
      return QuoteHelpers.sortProducts(filtered, listState);
    },
    refetchOnWindowFocus: false,
    enabled: list.isSuccess,
  });

  const updateQuery = useUpdateSearchQuery(
    searchContext.customerId,
    searchContext.searchType,
    listState,
  );

  return {
    query,
    updateQuery,
  };
}
